<template>
  <div>
    <data-list class="select_checkbox_column_width_0 stocklist" :payload="stockObj" :headers="headers" v-model="pagination" :total="total" :loading="stockObj.loading" :pagination="pagination">
      <template slot="expand">
        <v-simple-table dense width="100%" class="dense_table bordered--table">
          <thead>
            <tr>
              <th v-for="(expandHeader, index) in expandHeader" :key="index">{{expandHeader.text}}</th>
            </tr>
          </thead>
          <tbody v-for="(expandList, index) in stockObj.expanded" :key="index">
            <template v-for="(stock, i) in stocksPerLocation">
              <tr :key="`${i}_location`">
                <td width="20%">{{ stock.warehousename }}</td>
                <td>
                  <v-row>
                    <v-col class="pa-0" cols="10">
                      {{ stock.locationname }}
                    </v-col>
                    <v-col class="pa-0 text-right" cols="2" @click="changeLocationDialog(stock.warehouseid, expandList.productid, stock.onstock, stock.locationid)" v-if="!stock.receivedorderwithbatches">
                      <v-icon size="20">mdi-pencil</v-icon>
                    </v-col>
                  </v-row>
                </td>
                <td>{{ stock.onstock }}</td>
                <td>{{ stock.oncustomerorder }}</td>
                <td>{{ stock.available }}</td>
              </tr>
              <tr style="background: rgba(0,0,0,0.12);" v-for="(batch, j) in stock.receivedorderwithbatches" :key="`${stock.warehouseid}_${stock.locationid}_${j}_batch`">
                <td class="text-center">{{ batch.batchnumber }}</td>
                <td></td>
                <td>{{ batch.onstock | replaceDotWithComma }}</td>
                <td></td>
                <td></td>
              </tr>
            </template>
          </tbody>
        </v-simple-table>
      </template>
      <v-container fluid slot="filterForm" grid-list-xl>
        <v-layout row class="mb-0">
          <v-flex sm2 lg5>
              <v-menu offset-y>
                <template v-slot:activator="{ on }">
                  <v-btn color="primary" dark v-on="on">{{$t('message.common.add')}}</v-btn>
                </template>
                <v-list>
                  <v-list-item v-for="(item, index) in menuItems" :key="index" :to="item.to">
                    <v-list-item-title>{{ $t(item.title) }}</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </v-flex>
            <v-flex sm1 lg1>
              <v-btn fab dark small color="success" :loading="loadingForExcel">
                <v-icon dark @click="generateXslx" id="generateexcel">mdi-file-excel</v-icon>
              </v-btn>
            </v-flex>
            <v-flex sm3 lg2>
              <v-select dense outlined clearable class="pt-0" v-model="filterObj.warehouse" @change="getStockListHandler" :items="listOfWarehouse" item-text="name" item-value="id"  :label="$t('message.layout.warehouse')" id="warehouseauto"></v-select>
            </v-flex>
            <v-spacer></v-spacer>
            <v-flex sm3 lg2 class="text-right">
              <v-text-field outlined dense persistent-hint :hint="$t('message.common.searchTriggerHint')" clearable append-icon="search" @keyup.enter="searchLoading = true;getStockListHandler(true)" @click:append="searchLoading = true;getStockListHandler(true)" v-model="filterObj.numbersearch" :loading="searchLoading" :placeholder="$t('message.product.numberSearch')" :label="$t('message.product.numberSearch')" class="search-hint-padding" id="searchbtn"></v-text-field>
              <!-- <v-text-field persistent-hint :hint="$t('message.common.searchTriggerHint')" clearable append-icon="search" @keyup.enter="searchLoading = true;getStockListHandler(true)" @click:append="searchLoading = true;getStockListHandler(true)" dense outlined :loading="searchLoading" v-model="filterObj.searchterm" :label="$t('message.common.search')" class="text-xs-right pt-0 search-hint-padding" id="searchbtn"></v-text-field> -->
            </v-flex>
            <v-flex sm3 lg2 class="text-right">
              <v-text-field outlined dense persistent-hint :hint="$t('message.common.searchTriggerHint')" clearable append-icon="search" @keyup.enter="searchLoading = true;getStockListHandler(true)" @click:append="searchLoading = true;getStockListHandler(true)" v-model="filterObj.namesearch" :loading="searchLoading" :placeholder="$t('message.product.nameSearch')" :label="$t('message.product.nameSearch')" class="search-hint-padding" id="searchnamebtn"></v-text-field>
            </v-flex>
        </v-layout>
      </v-container>
    </data-list>
    <v-dialog persistent max-width="600px" v-model="locationChangeDialog">
      <v-card>
        <v-card-title>
          <h3>{{$t('message.warehouse.moveProduct')}}</h3>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pt-2 pb-2">
          <v-autocomplete v-model="quickLocationObj.tolocationid" :items="listOfLocations" autocomplete="off"  class="mt-1"
            @keyup="$event.keyCode !== 13 ? getWarehouseLocations('searchLocation', $event) : ''"
            ref="searchLocation" outlined dense
            @click="toggleLocations(SHOW)"
            @focusout="toggleLocations(HIDE, quickLocationObj.tolocationid)"
            item-text="name" item-value="id"
            hide-details :placeholder="$t('message.order.searchLocation')">
            <template v-slot:no-data>
              <span class="pa-1 caption">{{ $t('message.common.noResults') }}</span>
            </template>
          </v-autocomplete>
          <v-checkbox dense hide-details class="mt-3" v-model="quickLocationObj.setasdefaultlocation" :label="$t('message.warehouse.changeDefaultLoc')"></v-checkbox>
          <v-progress-linear v-if="loadingLocations" rounded indeterminate></v-progress-linear>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-flex class="text-center">
            <v-btn color="success" @click="changeTheLocationHandler">{{$t('message.common.change')}}</v-btn>
            <v-btn color="error" class="ml-2" @click="locationChangeDialog = false">{{$t('message.common.close')}}</v-btn>
          </v-flex>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import DataList from '../../../components/DataList'
export default {
  components: {
    DataList
  },
  data () {
    return {
      filterObj: {
        numbersearch: '',
        namesearch: ''
      },
      search: '',
      menuItems: [{ title: 'message.whOrder.supplierOrder', to: '/w_h/order/supplierorder/actions' },
        { title: 'message.warehouse.lowStockProposal', to: '/w_h/order/lowstockproposal' },
        { title: 'message.whOrder.adjustmentOrder', to: '/w_h/order/adjustmentorder/actions' },
        { title: 'message.whOrder.returnOrder', to: '/w_h/order/returnorder/actions' },
        { title: 'message.whOrder.transferOrder', to: '/w_h/order/transferorder/actions' }],
      stockObj: {
        expand: true,
        isHeader: true,
        isHideAdd: true,
        hasFilters: true,
        expanded: [],
        selection: [],
        showSelect: false,
        isStock: true,
        hideSelect: true,
        expandHeader: [],
        onExpand: ({ item }) => this.getStockItems(item),
        expandItem: 'stocksperlocation',
        editProp: 'productnumber',
        editURL: (item) => `/w_h/products/actions/${item.productid}`,
        editProp1: 'oncustomerorder',
        editURL1: (item) => `/orders?ids=${JSON.stringify(item.listofcustomerorders)}`,
        editProp2: 'onorder',
        editURL2: (item) => `/w_h/order?ids=${JSON.stringify(item.listofwarehouseorders)}`,
        editProp3: 'inproduction',
        editURL3: (item) => `/orders?ids=${JSON.stringify(item.listofproductionorders)}`,
        list: [],
        loading: false,
        page: 1
      },
      locationChangeDialog: false,
      total: 0,
      loadingForExcel: false,
      listOfWarehouse: [],
      stocksPerLocation: [],
      pagination: !this.$formatter.isEmptyObject(this.$store.state.STOCK_INDEX) ? this.$store.state.STOCK_INDEX : { sortBy: ['productnumber'], itemsPerPage: 25, sortDesc: [false], search: '' },
      searchLoading: false,
      listOfLocations: [],
      loadingLocations: true,
      quickLocationObj: {
        warehouseid: 0,
        fromlocationid: 0,
        tolocationid: 0,
        productid: 0,
        qty: 0
      }
    }
  },
  watch: {
    pagination (val) {
      let model = {
        type: 'STOCK_INDEX',
        data: val
      }
      this.$store.commit('rememberOrder', model)
      this.getStockListHandler()
    },
    'filterObj.numbersearch' (val) {
      if (!val) {
        this.searchLoading = true
        this.getStockListHandler(true)
      }
    },
    'filterObj.namesearch' (val) {
      if (!val) {
        this.searchLoading = true
        this.getStockListHandler(true)
      }
    }
  },
  computed: {
    headers () {
      return [{
        text: '', value: 'data-table-expand'
      }, {
        text: this.$t('message.product.number'),
        value: 'productnumber',
        width: '15%'
      }, {
        text: this.$t('message.customer.name'),
        value: 'description',
        width: '25%'
      }, {
        text: this.$t('message.product.salePrice'),
        value: 'saleprice',
        width: '10%',
        align: 'right'
      }, {
        text: this.$t('message.product.minStock'),
        value: 'minstock',
        width: '5%',
        align: 'right'
      }, {
        text: this.$t('message.stock.onStock'),
        value: 'onstock',
        width: '10%',
        align: 'right'
      }, {
        text: this.$t('message.stock.onOrder'),
        value: 'onorder',
        width: '10%',
        align: 'right'
      }, {
        text: this.$t('message.whOrder.reserved'),
        value: 'oncustomerorder',
        sortable: false,
        width: '10%',
        align: 'right'
      }, {
        text: this.$t('message.warehouse.inProduction'),
        value: 'inproduction',
        sortable: false,
        width: '8%',
        align: 'right'
      }, {
        text: this.$t('message.product.available'),
        value: 'available',
        width: '10%',
        align: 'right'
      }]
    },
    expandHeader () {
      return [ {
        text: this.$t('message.layout.warehouse'),
        value: 'warehousename',
        width: '10%'
      }, {
        text: this.$t('message.stock.location'),
        value: 'locationname',
        width: '10%'
      }, {
        text: this.$t('message.stock.onStock'),
        value: 'onstock',
        width: '10%'
      }, {
        text: this.$t('message.whOrder.reserved'),
        value: 'oncustomerorder',
        width: '10%'
      }, {
        text: this.$t('message.product.available'),
        value: 'available',
        width: '10%'
      }]
    }
  },
  mounted () {
    this.stockObj.loading = true
    this.getSupportListHandler()
    if (!this.$formatter.isEmptyObject(this.$store.state.F_WAREHOUSE)) {
      let warehouseFilters = this.$formatter.cloneVariable(this.$store.state.F_WAREHOUSE)
      let { warehouse, searchterm } = warehouseFilters.filter
      this.filterObj.warehouse = warehouse || 0
      this.filterObj.searchterm = searchterm
    }
    this.filterObj.numbersearch = this.pagination.numbersearch || ''
    this.filterObj.namesearch = this.pagination.namesearch || ''
  },
  methods: {
    getStockListHandler (isSearch = false) {
      this.stockObj.loading = true
      /* Added to store search in pagination */
      let { page, sortBy, sortDesc, itemsPerPage } = this.$formatter.cloneVariable(this.pagination)
      let pageVal = page || 1
      if (isSearch) pageVal = 1
      let requestModel = { warehouse: this.filterObj.warehouse || 0, sortby: sortBy[0], rowsperpage: itemsPerPage, page: pageVal, descending: sortDesc[0], numbersearch: this.filterObj.numbersearch || '', namesearch: this.filterObj.namesearch || '' }
      let paginationModel = this.$formatter.cloneVariable(this.pagination)
      paginationModel.numbersearch = this.filterObj.numbersearch
      paginationModel.namesearch = this.filterObj.namesearch
      let model = { type: 'STOCK_INDEX', data: paginationModel }
      this.$store.commit('rememberOrder', model)
      this.$_executeApi('post', `stocks/filter`, requestModel)
        .then((response) => {
          let values = response.data.items
          this.stockObj.expandHeader = []
          this.stockObj.expanded = []
          let transformList = { number: { list: ['saleprice', 'onorder', 'available', 'inproduction', 'minstock'], format: 'replaceDotWithComma' } }
          let model = this.$_formatListModel(values, transformList)
          model.forEach((item, index) => {
            item.id = index
            let getAvailable = (item.onstock - item.oncustomerorder)
            item.available = this.$formatter.replaceDotWithComma(getAvailable)
            item.oncustomerorder = this.$formatter.replaceDotWithComma(item.oncustomerorder)
            item.onstock = this.$formatter.replaceDotWithComma(item.onstock)
          })
          this.stockObj.list = model
          this.total = response.data.total
          let data = { type: 'F_WAREHOUSE', data: { filter: this.filterObj } }
          this.$store.commit('rememberFilter', data)
          if (page > 1 && this.total <= itemsPerPage * (page - 1)) {
            this.pagination.page = 1
            this.stockObj.page = 1
          }
        })
        .finally(() => {
          this.stockObj.loading = false
          this.searchLoading = false
        })
    },
    getSupportListHandler () {
      let query = {
        'filter': 'isactive eq 1',
        'order_by': { field: 'name', asc_or_desc: 'asc' }
      }
      this.$_executeApi('post', 'warehouses/query', query).then(response => {
        this.listOfWarehouse = response.data
        let item = this.listOfWarehouse.find(x => x.isdefault)
        if (item) {
          this.filterObj.warehouse = item.id
        }
      })
    },
    getStockItems (payload) {
      this.stockObj.loading = true
      this.stocksPerLocation = []
      let filterObj = {
        searchterm: '',
        warehouse: this.filterObj.warehouse || null,
        productid: payload.productid
      }
      this.stocksPerLocation = []
      this.$_executeApi('post', 'stocks/filter', filterObj)
        .then((response) => {
          let values = response.data.items
          let stocksPerLocation = []
          values.forEach((item) => {
            let listOfStocks = this.$formatter.cloneVariable(item.stocksperlocation)
            listOfStocks.map((x) => {
              x.available = this.$formatter.replaceDotWithComma(x.available)
              x.onstock = this.$formatter.replaceDotWithComma(x.onstock)
              x.oncustomerorder = this.$formatter.replaceDotWithComma(x.oncustomerorder)
              x.onorder = this.$formatter.replaceDotWithComma(x.onorder)
              x.inproduction = this.$formatter.replaceDotWithComma(x.inproduction)
            })
            stocksPerLocation.push(...listOfStocks)
          })
          this.stocksPerLocation = [...stocksPerLocation]
        })
        .finally(() => {
          this.stockObj.loading = false
        })
    },
    generateXslx () {
      let model = {}
      this.loadingForExcel = true
      this.$_executeApi('post', `stocks/generate_xlsx_report`, model)
        .then(response => {
          window.open(process.env.VUE_APP_URL + 'file/download?fileName=' + response.data, '_blank')
        })
        .finally(() => {
          this.loadingForExcel = false
        })
    },
    changeLocationDialog (warehouseId, productId, onStock, locationid) {
      this.locationChangeDialog = true
      this.quickLocationObj.setasdefaultlocation = true
      this.quickLocationObj.fromlocationid = locationid
      this.quickLocationObj.tolocationid = 0
      this.quickLocationObj.warehouseid = warehouseId
      this.quickLocationObj.productid = productId
      this.quickLocationObj.qty = this.$formatter.replaceCommaWithDot(onStock)
      this.getStockHandler(productId)
        .then((data) => {
          this.listOfLocations = data
        })
    },
    getStockHandler (productid) {
      return new Promise((resolve, reject) => {
        this.loadingLocations = true
        this.$_executeApi('get', `/stocks/get_product_by_warehouse?product_id=${productid}&warehouse_id=${this.quickLocationObj.warehouseid || 0}`)
          .then((result) => {
            let model = result.data
            model = model.filter(x => x.on_stock > 0)
            let transformData = { number: { list: ['on_stock'], format: 'replaceDotWithComma' } }
            model = this.$_formatListModel(model, transformData)
            model.map(x => {
              x.id = x.locationid
              x.name = x.location_name
              return x
            })
            this.loadingLocations = false
            resolve(model)
          })
          .catch((err) => {
            reject(err)
            this.loadingLocations = false
          })
      })
    },
    getWarehouseLocations (term, event) {
      if ([32, 37, 38, 39, 40, 30].indexOf(event.keyCode) > -1) return
      let searchText = this.$refs[term].lazySearch
      if (searchText !== null) {
        let query = {
          select: ['id', 'name', 'warehouseid', 'isdefault'],
          additionalfilters: [`name contains  '${searchText}'`],
          skip: 0,
          limit: 50,
          filter: `isactive eq 1 and warehouseid eq ${this.quickLocationObj.warehouseid || 0}`,
          'order_by': {
            'field': 'name',
            'asc_or_desc': 'asc'
          }
        }
        this.$_executeApi('post', 'warehouselocations/query', query).then((response) => {
          this.listOfLocations = response.data
        })
      }
    },
    async toggleLocations (action, locationid = 0) {
      if (locationid) {
        if (action === this.HIDE && this.listOfLocations) {
          let locations = this.listOfLocations.filter(x => x.id === locationid)
          this.listOfLocations = locations
        }
      }
    },
    changeTheLocationHandler () {
      this.$_executeApi('post', 'warehouseorderitems/quick_change_location', this.quickLocationObj)
        .then((response) => {
          if (response && response.data) {
            this.$root.$emit('snackbar', { snackbar: true, color: 'success', text: this.$t('message.common.actionPerformed') })
            this.locationChangeDialog = false
            this.getStockListHandler()
          } else {
            this.$root.$emit('snackbar', { snackbar: true, color: 'info', text: this.$t('message.stock.locationsAreSame') })
          }
        })
    }
  }
}
</script>
<style>
.stocklist .v-data-table--dense>.v-data-table__wrapper>table>tbody>tr>td {
  height: 26px !important;
}
</style>
